export default __webpack_public_path__ + "static/media/nfc.0bec26da.svg";